(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/legal-info/assets/javascripts/react/components/login-check/self-exclusion-info/gaming-paused.js') >= 0) return;  svs.modules.push('/modules/legal-info/assets/javascripts/react/components/login-check/self-exclusion-info/gaming-paused.js');

'use strict';

const {
  Currency: currency
} = svs.utils.format;
const {
  logger
} = svs.legal_info;
const {
  useState
} = React;
const {
  ReactIcon: Icon,
  ReactButton: Button
} = svs.ui;
const {
  isPnp
} = svs.legal_info.data;
const {
  isPoker
} = svs.legal_info.data.loginCheckOptions.model;
const {
  returnUrl,
  activeExclusionsArray,
  hasExpiredPause,
  expiredVerticals,
  hasTotalPause,
  hasGCSRestriction,
  balance
} = svs.legal_info.data.loginCheckOptions.model;
const GamingPaused = () => {
  const [checked, setChecked] = useState(false);
  const getGCSPauses = exclusions => {
    if (!exclusions || !Array.isArray(exclusions)) {
      return null;
    }
    const gcsPauses = exclusions.filter(exclusion => {
      var _exclusion$subSystem;
      return exclusion.isGCS === true || ((_exclusion$subSystem = exclusion.subSystem) === null || _exclusion$subSystem === void 0 ? void 0 : _exclusion$subSystem.includes('GCS'));
    });
    if (gcsPauses.length === 0) {
      return null;
    }
    return gcsPauses.map(pause => pause.subSystem).join(', ');
  };
  const handleDontShowAgainChange = e => {
    const isChecked = e.target.checked;
    setChecked(isChecked);
  };
  const handleNextButtonClick = e => {
    if (checked) {
      e.preventDefault();
      svs.core.jupiter.call({
        method: 'PUT',
        path: '/player/1/onlineflag/lcHideVertical'
      }, () => {
        svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl));
      }, err => {
        logger.error('Unable to PUT to set flag lcHideVertical at /player/1/onlineflag/lcHideVertical', err);
        svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl));
      });
    }
  };
  return React.createElement("section", {
    className: "f-content"
  }, React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement("div", {
    "aria-hidden": "true",
    className: "margin-top-1 margin-bottom-2 align-center"
  }, React.createElement(Icon, {
    color: isPnp ? 'fc-momang' : 'fc-sport-75',
    icon: "pause",
    size: "1000"
  })), React.createElement("div", {
    className: "padding-xs-h-1"
  }, React.createElement("h1", {
    className: "align-center f-prominent"
  }, "Spelpaus aktiverad"), hasGCSRestriction && React.createElement("div", {
    className: "margin-top-2"
  }, getGCSPauses(activeExclusionsArray)), React.createElement("div", {
    className: "margin-top-1"
  }, "Du \xE4r pausad fr\xE5n:"), activeExclusionsArray && activeExclusionsArray.map(exclusion => React.createElement("div", {
    key: exclusion.subSystem
  }, exclusion.subSystem, ' ', "(", exclusion.isExpired ? 'Upphörde' : 'Till och med', ' ', exclusion.textFormatDate, ")")), hasExpiredPause && React.createElement("div", {
    className: "padding-top-1"
  }, React.createElement("span", {
    className: "f-bold"
  }, "Observera"), ": F\xF6r att kunna spela", ' ', expiredVerticals, ' ', "igen beh\xF6ver du kontakta Kundservice via telefon 0770-11 11 11."), hasTotalPause ? balance > 0 && React.createElement("p", {
    className: "margin-top-1"
  }, "Du har", ' ', currency(balance), ' ', "kr p\xE5 ditt spelkonto. Du kan g\xF6ra ett uttag via \xF6verf\xF6ringar.") : React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement("div", {
    className: "form-checkbox"
  }, React.createElement("input", {
    checked: checked,
    className: "dont-show-again",
    id: "dontShowAgain",
    name: "dontShowAgain",
    onChange: handleDontShowAgainChange,
    type: "checkbox"
  }), React.createElement("label", {
    className: "form-label",
    htmlFor: "dontShowAgain"
  }, "Visa inte information om aktuella pauser vid inloggning utan endast vid betalning samt under sidan spelpaus (G\xE4ller tills ny paus s\xE4tts)."))), React.createElement("div", {
    className: "grid-row gutter-xs-1 margin-top-2"
  }, isPoker ? React.createElement("div", {
    className: "col-xs-6 col-xs-offset-3"
  }, React.createElement(Button, {
    block: true,
    href: returnUrl,
    inverted: true,
    onClick: handleNextButtonClick
  }, "G\xE5 vidare")) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "col-xs-6"
  }, React.createElement(Button, {
    block: true,
    href: "/logga-ut",
    transparent: true
  }, "Logga ut")), React.createElement("div", {
    className: "col-xs-6"
  }, React.createElement(Button, {
    block: true,
    focus: !isPnp,
    href: returnUrl,
    inverted: !isPnp,
    onClick: handleNextButtonClick
  }, "G\xE5 vidare")))), React.createElement("div", {
    className: "margin-top-2"
  }, "Har du fr\xE5gor? Kontakta", ' ', isPoker ? React.createElement("span", null, "Kundservice Svenska Spel Sport & Casino: 0770 - 11 11 11") : React.createElement("a", {
    className: isPnp ? 'fc-momang' : 'fc-sport-75',
    href: svs.core.urlMapping.get('customerServiceContact')
  }, "Kundservice Svenska Spel Sport & Casino")))));
};
svs.legal_info.components.login_check.self_exclusion_info.GamingPaused = GamingPaused;

 })(window);